var map = {
	"./barchart.png": "TUuS",
	"./linechart.png": "Fwc2",
	"./map.png": "GzPb",
	"./piechart.png": "u0iK",
	"./progress_bar.png": "NKy9",
	"./table.png": "gU32",
	"./text.png": "NdHi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2hnZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/canvas ^\.\/.*$
// module id = 2hnZ
// module chunks = 46